const n = 4, s = Array(64).fill(4).map((p, a) => p * a), c = s.map((p, a) => `var(--spacing-${a})`), i = s.map((p, a) => `--spacing-${a}:${p}px;`).join("");
export {
  n as BaseSpacing,
  s as Spacings,
  i as SpacingsCSSVariables,
  c as ThemeSpacingsProperties
};
